import axios from '~/utils/axios';
import { urlWithParams } from '~/utils';
import { Transfer, TransfersFilters } from '~/types/Transfer';

type GetTransfersResponse = {
  cursors: {
    next?: string;
  };
  transfers?: Transfer[];
};

interface getTransfersProps {
  next?: string | null;
  filters?: TransfersFilters;
}

interface Actions {
  [x: string]: {
    skip: boolean;
    submit: boolean;
  };
}

export const getTransfers = (props: getTransfersProps) => {
  const { filters, next } = props;
  const url = `/transaction/transfers/search`;

  return axios.get<GetTransfersResponse>(urlWithParams(url, { next, limit: 50, ...filters }));
};

export const getTransferLedgerMappingActions = (transferId: string) => {
  const url = `/transaction/transfers/${transferId}/ledgerMapping/actions`;
  return axios.get<Actions>(url).then((response) => response.data);
};

export const skipTransferLedgerMapping = (transferId: string, system: string) => {
  const url = `/transaction/transfers/${transferId}/ledgerMapping/${system}/skip`;
  return axios.post<{ success: boolean }>(url).then((response) => response.data);
};

export const submitTransferLedgerMapping = (transferId: string, system: string) => {
  const url = `/transaction/transfers/${transferId}/ledgerMapping/${system}/submit`;
  return axios.post<{ success: boolean }>(url).then((response) => response.data);
};
